import LastNewsCard from './LastNewsCard/LastNewsCard';
import ErrorState from 'common/ErrorState/ErrorState';
import Button from 'common/Button/Button';
import { useHistory } from 'react-router-dom';
import { useRevealGroup } from 'hooks/useReveal';
import { useContent } from 'hooks/useContent';
import Loader from 'components/Loader/Loader';
import './LastNews.css';
import { useLanguage } from 'hooks/useLanguage';

/**
 * Останні новини на головній — ADR-0006.
 *
 * Секція сама питає свій розділ: раніше новини вантажила головна сторінка й
 * передавала масив донизу, тому секція не знала, чи запит іще йде, чи вже впав.
 * Збій тепер лишається всередині секції: решта головної працює як звичайно.
 */
export default function LastNews() {
  const language = useLanguage();
  const { data: articles, status, error, retry, isLoading } = useContent('articles');
  const history = useHistory();
  const gridRef = useRevealGroup('.last-news-card', {}, status);

  const latest = articles
    .filter((article) => article.type === 'Новина')
    .slice(-3)
    .reverse();

  // Порожній розділ новин не є подією для головної: секція просто зникає.
  // А от збій ховати не можна, інакше сторінка мовчки недоказує.
  if (status === 'succeeded' && latest.length === 0) return null;

  return (
    <section className='last-news section'>
      <div className='container'>
        <div className='section-head section-head--split'>
          <h2 className='section-title'>{language === 'en' ? 'Latest news' : 'Останні новини'}</h2>
          <Button
            variant='link'
            buttonText={language === 'en' ? 'All news' : 'Усі новини'}
            onClick={() => history.push('/news')}
          />
        </div>

        {isLoading && <Loader />}

        {status === 'failed' && <ErrorState error={error} onRetry={retry} />}

        {status === 'succeeded' && (
          <div className='news-grid' ref={gridRef}>
            {latest.map((article) => (
              <LastNewsCard key={article.id} article={article} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
